import Link from 'next/link';
import type { UserProfile } from '../../../lib/auth';

interface LandingHeaderProps {
  isAuthenticated: boolean;
  isAuthLoadingState: boolean;
  primaryCtaLabel: string;
  userProfile: UserProfile | null;
  onStartTest: () => void;
}

export const LandingHeader = ({
  isAuthenticated,
  isAuthLoadingState,
  primaryCtaLabel,
  userProfile,
  onStartTest,
}: LandingHeaderProps) => (
  <header className="pt-6 pb-5">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="flex items-center justify-between gap-4">
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="flex items-center gap-2 text-lg font-serif tracking-tight text-[#1d1f24] hover:text-[#c43b3b] transition-colors"
        >
          <span>
            Test<span className="text-[#c43b3b] font-semibold">Portrait</span>
          </span>
        </button>

        <div className="flex items-center gap-2 sm:gap-3">
          {isAuthenticated ? (
            <>
              <div className="hidden sm:inline-flex items-center gap-2 rounded-full border border-[#e4e1d8] bg-white px-3 py-1 text-sm text-[#5d606a]">
                <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" />
                <span className="font-medium">Hi, {userProfile?.first_name || 'Friend'}</span>
              </div>
              <Link
                href="/dashboard"
                className="hidden sm:inline-flex items-center gap-2 rounded-full border border-[#e4e1d8] bg-white px-3 py-1.5 text-sm font-semibold text-[#1d1f24] transition-colors hover:border-[#c43b3b]/50 hover:text-[#c43b3b]"
              >
                Dashboard
              </Link>
            </>
          ) : isAuthLoadingState ? (
            <div className="text-sm text-[#5d606a]">Checking status&hellip;</div>
          ) : (
            <Link
              href="/login"
              className="inline-flex items-center rounded-full border border-[#e4e1d8] bg-white px-3 py-1.5 text-sm font-semibold text-[#1d1f24] transition-colors hover:border-[#c43b3b]/50 hover:text-[#c43b3b]"
            >
              Sign In
            </Link>
          )}
          <button
            onClick={onStartTest}
            className="inline-flex items-center justify-center bg-[#c43b3b] text-white text-sm font-semibold py-2 px-4 rounded-full shadow-[0_6px_18px_rgba(196,59,59,0.25)] hover:bg-[#b03434] transition-colors duration-200"
          >
            {primaryCtaLabel}
          </button>
        </div>
      </div>

      {isAuthenticated && (
        <div className="mt-3 flex items-center gap-2 sm:hidden">
          <div className="inline-flex items-center gap-2 rounded-full border border-[#e4e1d8] bg-white px-3 py-1 text-xs text-[#5d606a]">
            <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" />
            <span className="font-medium">Hi, {userProfile?.first_name || 'Friend'}</span>
          </div>
          <Link
            href="/dashboard"
            className="inline-flex items-center gap-2 rounded-full border border-[#e4e1d8] bg-white px-3 py-1 text-xs font-semibold text-[#1d1f24] transition-colors hover:border-[#c43b3b]/50 hover:text-[#c43b3b]"
          >
            Dashboard
          </Link>
        </div>
      )}
    </div>
  </header>
);
